import { Field, InputType, ObjectType } from 'type-graphql'

import { modelOptions, Prop } from '@typegoose/typegoose'
import { User, UserTypeEnum } from '@ztechapps/common.contract'

@ObjectType()
@InputType('TeacherInput')
@modelOptions({ schemaOptions: { timestamps: true, strict: false, collection: 'users' } }) //we need to define the collection name here, as the users, because it will use that collection
export class Teacher extends User {
  @Field(() => String)
  @Prop({ type: String, default: UserTypeEnum.teacher })
  declare type: UserTypeEnum
}
